export const CREATE_SERIES_VALUE = '__create__';

export const normalizeSeriesName = (name) => String(name || '').trim();

export const seriesIdOrNull = (value) => {
  if (!value || value === CREATE_SERIES_VALUE) return null;
  return value;
};

export const getSessionSeriesName = (session) =>
  session?.session_series?.name || session?.session_series_name || null;

/**
 * Infer a single series from the sessions in a block.
 * Returns null when none are assigned, mixed when they disagree.
 */
export const inferBlockSeries = (sessions = []) => {
  const assigned = (sessions || []).filter((session) => session?.session_series_id);
  if (assigned.length === 0) return null;

  const firstId = assigned[0].session_series_id;
  const allSame = assigned.every((session) => session.session_series_id === firstId);
  if (!allSame) {
    return { id: null, name: null, mixed: true };
  }

  const named = assigned.find((session) => getSessionSeriesName(session));
  return {
    id: firstId,
    name: getSessionSeriesName(named),
    mixed: false,
  };
};
